// extracted by css-extract-rspack-plugin
export default {"cls1":"PreprintExportStep-cls1_ar-","cls2":"PreprintExportStep-cls2_GyV PreprintExportStep-cls1_ar-"};